
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { mixins } from "vue-class-component";
import { takeMixin } from "./takeMixin";
@Component({})
export default class Name extends mixins(takeMixin) {
  async startTakePhoto() {
    console.log("触发拍摄");
    if (this.filming) {
      return;
    }
    this.imgData = [];
    this.filming = true;
    console.log("第一次拍摄");

    try {
      // 等待100ms后开始拍摄
      await new Promise(resolve => setTimeout(resolve, 100));

      // 第一次拍摄
      await this.takePhoto();
      console.log("第一次拍摄完成");

      // 第二次拍摄
      await this.changeLight();
      console.log("第二次拍摄");
      await this.takePhoto();
      console.log("第二次拍摄完成");

      // 第三次拍摄
      await this.changeLight();
      console.log("第三次拍摄");
      await this.takePhoto();
      console.log("第三次拍摄完成");

      console.log("白光-OFF");
      const res = await window.electronMyAPI.changeLight("白光-OFF");
      if (res) {
        console.log("返回值：" + res);
        console.log("保存图片");

        // 保存图片
        const loading = this.$loading({
          lock: true,
          text: "图片上传中……",
          spinner: "el-icon-loading",
          customClass: "loadClass",
          background: "rgba(255, 255, 255, 0.7)",
        });

        try {
          await this.upload(this.imgData[0]);
          await this.upload(this.imgData[1]);
          await this.upload(this.imgData[2]);

          loading.close();
          // 这里是为了方便重新拍摄
          console.log("保存成功");
          console.log("白光-ON-100");
          window.electronMyAPI.changeLight("白光-ON-100");
        } catch (error) {
          loading.close();
          console.error("上传失败:", error);
          this.$message.error("图片上传失败");
        } finally {
          this.filming = false;
        }
      }
    } catch (error) {
      console.error("拍摄过程出错:", error);
      this.$message.error("拍摄失败");
      this.filming = false;
    }
  }
  private mounted() {
    // this.getCameraDevices();
  }
}
